var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepSelectGoalActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 5C6.77614 5 7 5.22386 7 5.5V10.5C7 10.7761 6.77614 11 6.5 11C6.22386 11 6 10.7761 6 10.5V5.5C6 5.22386 6.22386 5 6.5 5ZM6 14H4.5C4.22386 14 4 13.7761 4 13.5C4 13.2239 4.22386 13 4.5 13H8.5C8.77614 13 9 13.2239 9 13.5C9 13.7761 8.77614 14 8.5 14H7V19.5C7 19.7761 6.77614 20 6.5 20C6.22386 20 6 19.7761 6 19.5V14ZM12 13.5C12 13.2239 11.7761 13 11.5 13C11.2239 13 11 13.2239 11 13.5V19.5C11 19.7761 11.2239 20 11.5 20C11.7761 20 12 19.7761 12 19.5V13.5ZM11.5 5C11.7761 5 12 5.22386 12 5.5V10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H11.5H9.5C9.22386 11 9 10.7761 9 10.5C9 10.2239 9.22386 10 9.5 10H11V5.5C11 5.22386 11.2239 5 11.5 5ZM16 16H14.5C14.2239 16 14 15.7761 14 15.5C14 15.2239 14.2239 15 14.5 15H18.5C18.7761 15 19 15.2239 19 15.5C19 15.7761 18.7761 16 18.5 16H17V19.5C17 19.7761 16.7761 20 16.5 20C16.2239 20 16 19.7761 16 19.5V16ZM16.5 5C16.7761 5 17 5.22386 17 5.5V12.5C17 12.7761 16.7761 13 16.5 13C16.2239 13 16 12.7761 16 12.5V5.5C16 5.22386 16.2239 5 16.5 5Z",
    fill: "#2468FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepSelectGoalActive);
export default __webpack_public_path__ + "static/media/step_select_goal_active.e3391740d62f55bb601e24001a322266.svg";
export { ForwardRef as ReactComponent };